export default __webpack_public_path__ + "db9b771.png";